export default {"src":"/_next/static/media/Handy-Asiatisch.739e9e3a.svg","height":737,"width":709,"blurWidth":0,"blurHeight":0};